import { useState, useCallback, type ReactNode } from "react";
import { SidebarToggleContext } from "./context";

const STORAGE_KEY_LEFT = "sidebar_left_collapsed";
const STORAGE_KEY_RIGHT = "sidebar_right_collapsed";

function readStorage(key: string): boolean {
  try {
    return localStorage.getItem(key) === "true";
  } catch {
    return false;
  }
}

export const SidebarToggleProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isLeftCollapsed, setLeftCollapsed] = useState(() =>
    readStorage(STORAGE_KEY_LEFT),
  );
  const [isRightCollapsed, setRightCollapsed] = useState(() =>
    readStorage(STORAGE_KEY_RIGHT),
  );

  const toggleLeft = useCallback(() => {
    setLeftCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem(STORAGE_KEY_LEFT, String(next));
      return next;
    });
  }, []);

  const toggleRight = useCallback(() => {
    setRightCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem(STORAGE_KEY_RIGHT, String(next));
      return next;
    });
  }, []);

  return (
    <SidebarToggleContext.Provider
      value={{ isLeftCollapsed, isRightCollapsed, toggleLeft, toggleRight }}
    >
      {children}
    </SidebarToggleContext.Provider>
  );
};
